'use client'

import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';
import Volume from "@/src/_types/volume";
import Volumes from "@/src/components/journal-site/archive/volumes/volumes";
import Issues from "@/src/components/journal-site/archive/issues/issues";
import ArchiveSelectorProps from "@/src/_types/Archive/archive-selector-props";

const ArchiveSelector: React.FC<ArchiveSelectorProps> = ({ volumes, issues}) => {
    const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);
    const [selectedVolume, setSelectedVolume] = useState<Volume>(volumes[0]);

    const handleTabChange = (event: React.SyntheticEvent, newIndex: number) => {
        setSelectedTabIndex(newIndex);
        setSelectedVolume(volumes[newIndex]);

        const activeIssue = document.getElementById('archive');
        if (activeIssue) {
            activeIssue.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    return (
        <Grid
            container
            direction="row"
            sx={{
                justifyContent: 'space-between',
                alignItems: 'flex-start',
            }}
            spacing={0}
        >
            <Grid size={6}>
                <Volumes volumes={volumes} value={selectedTabIndex} onChange={handleTabChange} />
            </Grid>
            <Grid size={6}>
                <Issues issues={issues} selectedVolume={selectedVolume} />
            </Grid>
        </Grid>
    );
};

export default ArchiveSelector;
